import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  container: {
    position: 'relative',
    ':not(#__unused__) input': {
      paddingRight: '28px',
    },
  },
  crossIcon: {
    display: 'flex',
    height: '16px',
    position: 'absolute',
    bottom: '11px',
    right: '10px',
    cursor: 'pointer',
  },
});
